var map = {
	"./featured-banner.de-CH.json": 1132,
	"./featured-banner.de-DE.json": 1133,
	"./featured-banner.en-CA.json": 1134,
	"./featured-banner.en-GB.json": 1135,
	"./featured-banner.en-IN.json": 1136,
	"./featured-banner.en-ME.json": 1137,
	"./featured-banner.en-US.json": 1138,
	"./featured-banner.es-EM.json": 1139,
	"./featured-banner.es-ES.json": 1140,
	"./featured-banner.fr-BE.json": 1141,
	"./featured-banner.fr-CA.json": 1142,
	"./featured-banner.fr-CH.json": 1143,
	"./featured-banner.nl-BE.json": 1144,
	"./featured-banner.nl-NL.json": 1145,
	"./featured-banner.pl-PL.json": 1146,
	"./featured-banner.pt-BR.json": 1147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1131;